import api from './api';

const BASE_URL = '/quality-metrics';

const qualityMetricService = {
  // Get all quality metrics with optional filters
  getQualityMetrics: async (params = {}) => {
    const response = await api.get(BASE_URL, { params });
    return response.data;
  },

  // Get a single quality metric by ID
  getQualityMetric: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Create a new quality metric
  createQualityMetric: async (data) => {
    const response = await api.post(BASE_URL, data);
    return response.data;
  },

  // Update an existing quality metric
  updateQualityMetric: async (id, data) => {
    const response = await api.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  // Delete a quality metric
  deleteQualityMetric: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Get quality metrics statistics
  getQualityMetricStats: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/stats`, { params });
    return response.data;
  }
};

export default qualityMetricService;

